export default __webpack_public_path__ + "8df95d9a40c807ba08add0df1a1475b2.svg";